/**
 * Big library ,
 * A proxy to deep import parts we use only
 */

import type { ComponentType } from 'react';
import type { TableProps, ColumnProps } from 'react-virtualized';
import { Column, Table } from 'react-virtualized/dist/commonjs/Table';

export { WindowScroller } from 'react-virtualized/dist/commonjs/WindowScroller';
export { List } from 'react-virtualized/dist/commonjs/List';
export { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';

export type {
	ListRowProps,
	ListRowRenderer,
	TableCellRenderer,
	TableProps,
	ColumnProps,
} from 'react-virtualized';

// @ts-expect-error - TS2352 - Conversion of type 'typeof Column' to type 'ComponentType<ColumnProps>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const ColumnTyped = Column as ComponentType<ColumnProps>;
// @ts-expect-error - TS2352 - Conversion of type 'typeof Table' to type 'ComponentType<TableProps>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const TableTyped = Table as ComponentType<TableProps>;

// Re-export with types
export { ColumnTyped as Column, TableTyped as Table };
